export default "__VITE_ASSET__ca8c96a3__"